export function OrderCardSkeleton() {
  return (
    <div className="space-y-3 rounded-2xl border border-zinc-100 bg-white p-4">
      <div className="flex items-center justify-between">
        <div className="h-4 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="h-6 w-20 animate-pulse rounded-full bg-[#F0E0C7]/60" />
      </div>
      <div className="flex gap-3">
        <div className="h-16 w-16 animate-pulse rounded-lg bg-[#F0E0C7]/60" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-3/4 animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-3 w-1/2 animate-pulse rounded bg-[#F0E0C7]/60" />
        </div>
      </div>
      <div className="h-10 w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
    </div>
  );
}

export default function OrdersSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <OrderCardSkeleton key={`order-${index}`} />
      ))}
    </div>
  );
}
